import { inject, Injectable } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { CLITemplateDetailsInterface } from '@shared/api';
import {
  FormButtonTypeEnum,
  FormComponent,
  FormControlTypeEnum,
  FormService,
} from '@shared/form';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomEntityCollectionBaseService } from '../entity-collection-base.class';
import { EntityTypeEnum } from '../entity.interface';
import { MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class CLITemplatesService extends CustomEntityCollectionBaseService<CLITemplateDetailsInterface> {
  private readonly formService = inject(FormService);

  firstEntity$ = this.entities$.pipe(map((entities) => entities[0]));

  constructor(elementsFactory: EntityCollectionServiceElementsFactory) {
    super(EntityTypeEnum.CliTemplate, elementsFactory);
  }

  createTemplate(
    entity: CLITemplateDetailsInterface,
  ): Observable<CLITemplateDetailsInterface> {
    return this.add(entity);
  }

  updateTemplate(
    entity: CLITemplateDetailsInterface,
  ): Observable<CLITemplateDetailsInterface> {
    return this.update(entity, { isOptimistic: true });
  }

  deleteTemplate(templateId: string): Observable<number | string> {
    return this.delete(templateId);
  }

  openUnsavedChangesModal(): MatDialogRef<FormComponent> {
    return this.formService.openForm({
      data: {
        title: $localize`:@@templateLeavePageModalTitle:Leave page?`,
        form: {
          ids: ['label'],
          controls: {
            label: {
              title: $localize`:@@templateLeavePageModalText:You have unsaved changes. If you leave now, your changes will be lost`,
              type: FormControlTypeEnum.LABEL,
            },
          },
        },
        actions: [
          {
            type: FormButtonTypeEnum.SECONDARY,
          },
          {
            type: FormButtonTypeEnum.PRIMARY,
            action: () => of(true),
          },
        ],
      },
    });
  }
}
